import { PieChart, Pie, Tooltip, Cell, Legend } from "recharts";
import GraficoComponent from "../GraficoComponent";
import { GraficoComponenteProps } from "../../interfaces/dashboardCard";
import NenhumDadoGrafico from "../NenhumDadoGrafico";
import { chavesValoresSiglas } from "../../interfaces/indicadorMensuracao";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

export default function GraficoPizza({ indicador }: GraficoComponenteProps) {
  const { sigla, indicadoresMensuracaos } = indicador;

  const chaveValor = sigla.toLowerCase() as keyof chavesValoresSiglas;

  const dadosFiltrados = indicadoresMensuracaos.filter(
    (item) => Number(item[chaveValor]) > 0
  );

  return (
    <GraficoComponent title={indicador.titulo}>
      {dadosFiltrados.length > 0 ? <PieChart>
        <Tooltip />
        <Legend />
        <Pie
          data={dadosFiltrados}
          dataKey={(entry) => Number(entry[chaveValor])}
          nameKey="periodo"
          outerRadius={120}
          fill="#8884d8"
          label
        >
          {dadosFiltrados.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart> :
        <NenhumDadoGrafico texto='Nenhum dado encontrado ' subtexto='para este gráfico' />
      }
    </GraficoComponent>
  );
}
